import { Container, Card, Row, Col } from "react-bootstrap";
import NavigationBar from "../components/navigationbar";
import zakat from "../assets/zakat.jpg";
import Footer from "../components/footer";
import cityskyline from "../assets/cityskyline.png";
import { PiCurrencyDollarBold } from "react-icons/pi";
import { LuApple } from "react-icons/lu";
import { SlBookOpen } from "react-icons/sl";
import { BsMoonStars } from "react-icons/bs";
import { FaHandHoldingHeart } from "react-icons/fa";
import ExpandableCardList from "../components/expandableCardList";
import SponsorsList from "../components/sponsors";

const IconWrapper = ({ icon }) => (
    <div
        style={{
            backgroundColor: "#336633",
            color: "white",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: "-25px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
        }}
    >
        {icon}
    </div>
);


const WhatWeDo = () => {


    return (
        <div className="position-relative">
            <NavigationBar />
            <div style={{
                backgroundImage: `url(${cityskyline})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center 80%',
                textAlign: 'left',
                height: '40vh',
                paddingTop: '20px',
            }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <h4 style={{ fontSize: '14px', textAlign: 'center', marginBottom: '30px' }}>
                        Greater Austin Muslim Relief Committee
                    </h4>
                    <div style={{ maxWidth: '700px' }}>
                        <h1 style={{ fontSize: '36px', marginBottom: '10px' }}>
                            What We Do:
                        </h1>
                        <p style={{ fontSize: '24px', lineHeight: '1.4', paddingRight: '250px' }}>
                            United for the good of humanity and the good of our community (Muslims and non-Muslims)
                        </p>
                    </div>
                </div>
            </div>

            <Container className="mt-4 px-4 mb-4">
                <p style={{ fontSize: "18px", lineHeight: "1.6", textAlign: "center" }}>
                    The Greater Austin Muslim Relief Committee (GAMRC) is committed to
                    supporting the Austin community by offering financial and humanitarian
                    assistance to those in need, all in the name of Allah. Through the unity
                    of local masjids and partnerships with charitable organizations, we work
                    to provide essential resources to individuals and families, ensuring that
                    their needs for food, shelter, medical care, and education are met.
                    Guided by the principles of Zakat and Sadaqah, our mission is to
                    alleviate hardship, promote welfare, and foster an environment of
                    compassion and support for all.
                </p>
                <hr style={{ height: '2px', backgroundColor: 'black' }} />
                <h2 className="mb-5">Our Work At GAMRC:</h2>
                <Row className="justify-content-center text-center">
                    {/* Financial Assistance */}
                    <Col md={4} sm={6} xs={12} className="mb-5">
                        <Card className="h-100 shadow p-3 pt-5" style={{ position: "relative", backgroundColor: "white" }}>
                            <IconWrapper icon={<PiCurrencyDollarBold size={24} />} />
                            <Card.Title>
                                <h5 style={{ fontWeight: "600", color: "#336633" }}>Financial Assistance</h5>
                            </Card.Title>
                            <Card.Body className="pt-0">
                                <ul className="text-start">
                                    <li>Rent and utilities</li>
                                    <li>Medical expenses</li>
                                    <li>Urgent debt</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Food Aid */}
                    <Col md={4} sm={6} xs={12} className="mb-5">
                        <Card className="h-100 shadow p-3 pt-5" style={{ position: "relative", backgroundColor: "white" }}>
                            <IconWrapper icon={<LuApple size={24} />} />
                            <Card.Title>
                                <h5 style={{ fontWeight: "600", color: "#336633" }}>Food Aid</h5>
                            </Card.Title>
                            <Card.Body className="pt-0">
                                <ul className="text-start">
                                    <li>Distributing food and groceries</li>
                                    <li>Ramadan food baskets</li>
                                    <li>Qurbani meat</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Educational Programs */}
                    <Col md={4} sm={6} xs={12} className="mb-5">
                        <Card className="h-100 shadow p-3 pt-5" style={{ position: "relative", backgroundColor: "white" }}>
                            <IconWrapper icon={<SlBookOpen size={24} />} />
                            <Card.Title>
                                <h5 style={{ fontWeight: "600", color: "#336633" }}>Educational Programs</h5>
                            </Card.Title>
                            <Card.Body className="pt-0 pb-2">
                                <ul className="text-start mb-3">
                                    <li>Tutoring for under served children</li>
                                    <li>English tutoring</li>
                                    <li>Quran classes for refugee children</li>
                                    <li>Chromebook funding for online learning</li>
                                </ul>
                                <div className="mt-auto d-flex justify-content-end">
                                <a
                                    href="/Education"
                                    style={{
                                        fontSize: '16px',
                                        color: '#294d29ff',
                                        fontFamily: 'Lora, serif',
                                        textDecoration: 'none'
                                    }}
                                >
                                    More Details →
                                </a>
                            </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="justify-content-center text-center">
                    {/* Ramadan & Eid Programs */}
                    <Col md={4} sm={6} xs={12} className="mb-5">
                        <Card className="h-100 shadow p-3 pt-5 d-flex flex-column justify-content-between" style={{ position: "relative", backgroundColor: "white" }}>
                            <div>
                                <IconWrapper icon={<BsMoonStars size={24} />} />
                                <Card.Title>
                                    <h5 style={{ fontWeight: "600", color: "#336633" }}>Ramadan & Eid Programs</h5>
                                </Card.Title>
                                <Card.Body className="pt-0 pb-2">
                                    <ul className="text-start mb-3">
                                        <li>Distributing food and groceries during Ramadan</li>
                                        <li>Organizing Eid activities</li>
                                        <li>Distributing goodie bags for kids</li>
                                        <li>Applying Henna/Mehndi for girls</li>
                                        <li>Distributing Qurbani meat</li>
                                        <li>Zakatul Fitr distribution</li>
                                    </ul>
                                </Card.Body>
                            </div>
                            {/* Bottom right button */}
                            <div className="mt-auto d-flex justify-content-end">
                                <a
                                    href="/Eid"
                                    style={{
                                        fontSize: '16px',
                                        color: '#294d29ff',
                                        fontFamily: 'Lora, serif',
                                        textDecoration: 'none'
                                    }}
                                >
                                    More Details →
                                </a>
                            </div>

                        </Card>
                    </Col>



                    {/* Community Engagement */}
                    <Col md={4} sm={6} xs={12} className="mb-5">
                        <Card className="h-100 shadow p-3 pt-5" style={{ position: "relative", backgroundColor: "white" }}>
                            <IconWrapper icon={<FaHandHoldingHeart size={24} />} />
                            <Card.Title>
                                <h5 style={{ fontWeight: "600", color: "#336633" }}>Community Engagement</h5>
                            </Card.Title>
                            <Card.Body className="pt-0">
                                <ul className="text-start">
                                    <li>Facilitating furniture, car, and food donation</li>
                                    <li>Organizing Eid activities</li>
                                    <li>Organizing school break programs for children</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} sm={12} className="mb-4 text-center align-self-center">
                        <hr
                            className="my-4"
                            style={{
                                border: "2px solid black",
                                height: "3px",
                                opacity: "1",
                                width: "30vh",
                                borderRadius: "5px",
                                margin: "auto",
                            }}
                        />
                        <h2>
                            "Is there any reward for good other than good?" <br />
                            — Surah Ar-Rahman (55:60)
                        </h2>
                        <p>
                            Uplift your Austin Muslim community. Volunteer your time, share your kindness, and be part of a cycle of
                            goodness.
                        </p>
                        <hr
                            className="my-4"
                            style={{
                                border: "2px solid black",
                                height: "3px",
                                opacity: "1",
                                width: "30vh",
                                borderRadius: "5px",
                                margin: "auto",
                            }}
                        />
                    </Col>
                    <Col>
                        <img src={zakat} alt="What We Do" className="img-fluid" style={{ width: "100%", height: "100%" }} />
                    </Col>
                </Row>
                <h2 className="mb-4">GAMRC Also Supports:</h2>

                <ExpandableCardList />
                <hr style={{ height: '2px', backgroundColor: 'black' }} />
                <h2 className="mb-4">Our Sponsors</h2>  
                <p style={{ fontSize: "18px", lineHeight: "1.6", textAlign: "center" }}>
                    JazakAllah to our sponsors for their generous support and contributions to the Greater Austin Muslim Relief Committee.
                    Their commitment to our mission helps us serve the community effectively.
                </p>
                <SponsorsList />

            </Container>
            <Footer />
        </div>
    );
};

export default WhatWeDo;
